import React, { useMemo } from 'react';
import { Box, Grid } from '@mui/material';
import { DealTypes } from 'api';
import { colors } from 'theme/constants';
import { formatCurrency } from 'helpers/formatters';
import { isNotEmptyValue } from 'helpers/common';
import { MetricCard, MetricCardProps } from 'components';

interface Props {
  deal: DealTypes.ItemDataExtended;
  inline?: boolean;
}

export type DealInfoItems = ({
  key: keyof DealTypes.ItemData | string;
} & MetricCardProps)[];

const PerformanceTab = (props: Props): JSX.Element | null => {
  const { deal, inline } = props;

  const primaryMetricsInfo: DealInfoItems = useMemo(
    () => [
      {
        key: 'budget_potential',
        subtitle: 'Budget potential',
        title: isNotEmptyValue(deal.budget_potential)
          ? formatCurrency(deal.budget_potential)
          : '-',
        color: colors.accent,
      },
      {
        key: 'roi_potential',
        subtitle: 'ROI potential',
        title: isNotEmptyValue(deal.roi_potential) ? deal.roi_potential : '-',
        color: colors.purple,
      },
      {
        key: 'revenue_potential',
        subtitle: 'Revenue potential',
        title: isNotEmptyValue(deal.revenue_potential)
          ? formatCurrency(deal.revenue_potential)
          : '-',
        color: colors.darkGreen,
      },
      {
        key: 'gross_profit_potential',
        subtitle: 'Gross profit',
        title: isNotEmptyValue(deal.gross_profit_potential)
          ? formatCurrency(deal.gross_profit_potential)
          : '-',
        color: colors.darkBlue,
      },
    ],
    [
      deal.budget_potential,
      deal.gross_profit_potential,
      deal.revenue_potential,
      deal.roi_potential,
    ],
  );

  return (
    <Box>
      <Grid container spacing={3}>
        {primaryMetricsInfo.map((item) => (
          <Grid item xs={12} sm={6} md={inline ? 6 : 3} key={item.key}>
            <MetricCard
              title={item.title}
              subtitle={item.subtitle}
              color={item.color}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PerformanceTab;
